module.exports = __webpack_public_path__ + "static/media/share-link-icon.af96a55c.svg";